import React, { useState } from 'react';
import { AppBar, Toolbar, styled, Button, IconButton, Menu, MenuItem } from '@mui/material';
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Info as InfoIcon,
  MedicalServices as ServicesIcon,
  ContactMail as ContactIcon
} from '@mui/icons-material';
import logo from './assets/CMSLogo.png';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const StyledAppBar = styled(AppBar)({
  zIndex: 9999, // Ensure the AppBar is displayed on top
});

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '80px',
  padding: '0 16px',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-between',
    padding: '0 8px',
    height: '70px',
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: 'white',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  marginLeft: '16px',
  borderRadius: '8px',
  padding: '8px 16px',
  fontWeight: 500,
  textTransform: 'none',
  transition: 'all 0.3s ease',
  backdropFilter: 'blur(10px)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const StyledLogo = styled('img')(({ theme }) => ({
  maxHeight: '100px',
  height: '100px',
  objectFit: 'contain',
  padding: '5px',
  [theme.breakpoints.down('sm')]: {
    maxHeight: '60px',
    height: '60px',
    padding: '2px',
  },
}));


const StyledMobileMenuButton = styled(IconButton)(({ theme }) => ({
  display: 'none',
  color: 'white',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.5)',
    },
  },
}));

function NavBar() {
  const [isMenuOpen, setMenuOpen] = useState(null);
  const theme = useTheme(); // Add this line to get the theme
  const handleMenuOpen = (event) => {
    setMenuOpen(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuOpen(null);
  };

  return (
    <StyledAppBar position="fixed">
      <StyledToolbar>
        <StyledLogo src={logo} alt="Logo" />

        {/* Desktop Navigation */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <StyledButton component={Link} to="/" startIcon={<HomeIcon />}>Home</StyledButton>
          <StyledButton component={Link} to="/about" startIcon={<InfoIcon />}>About</StyledButton>
          <StyledButton component={Link} to="/services" startIcon={<ServicesIcon />}>Services</StyledButton>
          <StyledButton component={Link} to="/contact" startIcon={<ContactIcon />}>Contact</StyledButton>
        </div>

        {/* Mobile Menu Button */}
        <StyledMobileMenuButton onClick={handleMenuOpen} color="inherit">
          <MenuIcon />
        </StyledMobileMenuButton>

        {/* Mobile Menu */}
        <Menu
          anchorEl={isMenuOpen}
          open={Boolean(isMenuOpen)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              backgroundColor: theme.palette.primary.main,
              color: 'white',
              minWidth: '200px',
              marginTop: '8px',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            },
          }}
        >
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: '12px 20px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <HomeIcon fontSize="small" />
            Home
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/about"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: '12px 20px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <InfoIcon fontSize="small" />
            About
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/services"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: '12px 20px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <ServicesIcon fontSize="small" />
            Services
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/contact"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: '12px 20px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <ContactIcon fontSize="small" />
            Contact
          </MenuItem>
        </Menu>
      </StyledToolbar>
    </StyledAppBar>
  );
}

export default NavBar;
